import React, { ReactElement } from 'react';
import CompanyPageLayout
  from '@fuww/library/src/Layouts/CompanyPage';
import UniqueSellingProposition
  from '@fuww/library/src/UniqueSellingProposition';
import AdaptiveCard from '@fuww/library/src/Cards/AdaptiveCard';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import PageCardContainer from '@fuww/library/src/PageCardContainer';
import Language from '@fuww/library/src/Icons/Language';
import Newspaper from '@fuww/library/src/Icons/Newspaper';
import Work from '@fuww/library/src/Icons/Work';
import Email from '@fuww/library/src/Icons/Email';
import { useIntl } from 'react-intl';
import TextWithImage from '../components/TextWithImage';
import getSourceSet from '../lib/getSourceSet';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Head from '../components/Head';
import ImageWithUrls from '../components/ImageWithUrls';
import messages from '../lib/messages.mjs';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import { textWithImageConfigurations, companyProfilesCardImageConfigurations }
  from '../lib/imageConfigurations';
import LinkAndAnchor from '../components/LinkAndAnchor';
import getProxiedImages from '../lib/getProxiedImages';

const imageUrls = {
  publishVacancies: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/job_ad_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/job_ad_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/job_ad_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/job_ad_image.png',
  ],
  employerBranding: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/employer_branding_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/employer_branding_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/employer_branding_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/employer_branding_image.png',
  ],
  contentMarketing: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/content_marketing_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/content_marketing_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/content_marketing_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/content_marketing_image.png',
  ],
  displayAdvertising: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/display_advertising_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/display_advertising_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/display_advertising_image.png',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/display_advertising_image.png',
  ],
};

const cardsData = [
  {
    title: 'Advertise',
    description: 'Advertise your brand on FashionUnited',
    route: 'display-advertising',
    cardImageUrls: [
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/advertise.jpg',
    ],
  },
  {
    title: 'Recruitment solutions',
    description: 'Find the best talent in fashion',
    href: '/company/recruitment-solutions',
    cardImageUrls: [
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/advertise.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/advertise.jpg',
    ],
  },
  {
    title: 'Submit your job postings',
    // eslint-disable-next-line max-len
    description: 'FashionUnited is there to boost your HR & marketing strategy in various ways',
    route: 'submit-job-postings',
    cardImageUrls: [
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=10,width=42/https://media.fashionunited.com/media/images/jobposting.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=360/https://media.fashionunited.com/media/images/jobposting.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=460/https://media.fashionunited.com/media/images/jobposting.jpg',
      'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,quality=70,width=920/https://media.fashionunited.com/media/images/jobposting.jpg',
    ],
  },
];

const uniqueSellingPropositionItems = [
  {
    id: 'visitors',
    icon: <Language />,
    text: '1.500.000 monthly visitors',
  },
  {
    id: 'articles',
    icon: <Newspaper />,
    text: '70.000+ articles published',
  },
  {
    id: 'jobs',
    icon: <Work />,
    text: '+ 100.000 jobs',
  },
  {
    id: 'newsletters',
    icon: <Email />,
    text: '30,000,000 newsletters sent per year',
  },
];

const CompanyPage = () => {
  const intl = useIntl();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: 'company',
    crumbLabel: intl.formatMessage(messages.company),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages.company)}
        description={intl.formatMessage(
          messages['companyLandingPage.metaDescription'],
        )}
      />
      <CompanyPageLayout
        breadcrumbs={breadcrumbs}
        title={intl.formatMessage(messages['companyLandingPage.title'])}
        description={intl.formatMessage(
          messages['companyLandingPage.description'],
        )}
        textWithImageComponents={(
          <>
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.publishVacancies.buttonLabel'],
              )}
              buttonRoute="submit-job-postings"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.publishVacancies.description'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.publishVacancies}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.publishVacancies,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.publishVacancies.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.employerBranding.buttonLabel'],
              )}
              buttonRoute="employer-branding"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.employerBranding.description'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.employerBranding}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.employerBranding,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.employerBranding.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.buttonLabel'],
              )}
              buttonRoute="content-marketing"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.description'],
              )}
              imagePosition="right"
              imageUrls={imageUrls.contentMarketing}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.contentMarketing,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.contentMarketing.title'],
              )}
            />
            <TextWithImage
              buttonLabel={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.buttonLabel'],
              )}
              buttonRoute="display-advertising"
              buttonVariant="contained"
              description={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.description'],
              )}
              imagePosition="left"
              imageUrls={imageUrls.displayAdvertising}
              srcSet={getSourceSet(
                textWithImageConfigurations, imageUrls.displayAdvertising,
              )}
              title={intl.formatMessage(
                messages['companyLandingPage.displayAdvertising.title'],
              )}
            />
          </>
        )}
        uniqueSellingProposition={
          <UniqueSellingProposition items={uniqueSellingPropositionItems} />
        }
      />
      <PageCardContainer pageCards={cardsData.map(({
        title,
        description,
        route,
        href,
        cardImageUrls: originalCardImageUrls,
      }) => {
        const { imageUrls: cardImageUrls, srcSet } = getProxiedImages(
          { imageConfigurations: companyProfilesCardImageConfigurations },
          originalCardImageUrls,
        );

        return (
          <LinkAndAnchor key={title} href={href} route={route} display="flex">
            <AdaptiveCard
              title={title}
              textAlign="left"
              description={description}
              image={cardImageUrls[0] && (
              <ImageWithUrls
                sizes={`
                      (min-width: 1440px) 318px,
                      (min-width: ${breakpoints.lg}px) calc(25vw - 42px),
                      (min-width: ${breakpoints.md}px) calc(50vw - 52px),
                      calc(100vw - 72px)
                    `}
                srcSet={srcSet}
                imageUrls={cardImageUrls}
                alt={title}
                disableRoundedCorners
              />
              )}
            />
          </LinkAndAnchor>
        );
      })}
      />
    </>
  );
};

CompanyPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Company page banner image"
      />
    )}
  >
    {page}
  </Layout>
);

export default CompanyPage;
